import { render, staticRenderFns } from "./DialogReceiptInfo.vue?vue&type=template&id=027f6b12&scoped=true&"
import script from "./DialogReceiptInfo.vue?vue&type=script&lang=js&"
export * from "./DialogReceiptInfo.vue?vue&type=script&lang=js&"
import style0 from "./DialogReceiptInfo.vue?vue&type=style&index=0&id=027f6b12&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "027f6b12",
  null
  
)

export default component.exports